import React, { Component, Fragment } from 'react';
import {
  NavBar, Card, WhiteSpace, Toast,
  Flex, ActivityIndicator, SearchBar,
} from 'antd-mobile';
import DocumentTitle from 'react-document-title';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEye, faEyeSlash, faArrowCircleLeft,
} from '@fortawesome/free-solid-svg-icons';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroller';
import styled from 'styled-components';

import { getDeviceList } from './api';
import { RefreshIcon } from './common';

const LoaderWrapper = styled.div`
  padding: 2em;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Loader = () => (
  <LoaderWrapper>
    <ActivityIndicator
      size="large"
      text="Loading..."
    />
  </LoaderWrapper>
);

const FixedContent = styled.div`
  margin-top: 51px;
`;

const NoMoreData = ({ hide }) => {
  if (hide) return null;
  return (
    <div style={{
      textAlign: 'center', padding: '2em', color: '#aaa', fontSize: '1.2em',
    }}
    >
      没有更多设备了
    </div>
  );
};

NoMoreData.propTypes = {
  hide: PropTypes.bool,
};

NoMoreData.defaultProps = {
  hide: true,
};

class Devices extends Component {
  constructor(...args) {
    super(...args);
    this.handleClickItem = this.handleClickItem.bind(this);
    this.navBack = this.navBack.bind(this);
    this.getDeviceList = this.getDeviceList.bind(this);
    this.filterByDeviceNo = this.filterByDeviceNo.bind(this);
    this.refreshList = this.refreshList.bind(this);
    this.loadMore = this.loadMore.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleSearchCancel = this.handleSearchCancel.bind(this);

    this.state = {
      syncing: false,
      devices: [],
      hasMore: true,
      page: 0,
      keyword: '',
      begin: '',
      end: '',
    };
  }

  async getDeviceList(page, begin, end) {
    const { match: { params: { user } } } = this.props;
    try {
      const pageSize = 20;
      const { data } = await getDeviceList(user, page, pageSize, begin, end);

      this.setState((prevState) => {
        let { devices } = prevState;
        // add 19-2
        if (begin && end) {
          devices = [];
        }

        return {
          page,
          begin,
          end,
          devices: [...devices, ...data],
          hasMore: begin ? false : data.length === pageSize,
          // hasMore: data.length === pageSize,
        };
      });
    } catch (error) {
      if (error.response) {
        Toast.fail(error.message, 2, null, false);
      } else {
        Toast.offline(error.message, 2, null, false);
      }
    }
  }

  filterByDeviceNo(begin, end) {
    this.setState({
      page: 0,
      begin,
      end,
      devices: [],
    }, () => {
      const { page } = this.state;
      this.getDeviceList(page + 1, begin, end);
    });
  }

  // v = '', then query all. 19-2, web ok but mobile not support
  handleSearchChange(v) {
    if (v) {
      this.setState({
        keyword: v,
      });
    } else {
      this.handleSearchCancel();
    }
  }

  loadMore() {
    const { page, begin, end } = this.state;
    this.getDeviceList(page + 1, begin, end);
  }

  refreshList() {
    this.setState({
      devices: [],
      page: 0,
      hasMore: true,
    });
  }

  handleClickItem(item) {
    const { match, history } = this.props;
    const { user } = match.params;
    if (user) {
      history.push(`/${user}/${item.id}`);
    }
  }

  navBack() {
    const { history } = this.props;
    if (history.length) {
      history.goBack();
    } else {
      history.push('/');
    }
  }

  handleSearch() {
    const { keyword } = this.state;
    const [begin, end] = keyword.replace(/[,，]/g, ' ').split(' ').filter(s => s);
    if (!begin) {
      return;
    }
    this.filterByDeviceNo(begin, end || begin);
  }

  handleSearchCancel() {
    this.setState({
      keyword: '',
      begin: '',
      end: '',
    });
    this.refreshList();
  }

  render() {
    const {
      hasMore, syncing = false, devices = [], keyword,
    } = this.state;
    const { location } = this.props;
    const pageTitle = location.state ? location.state.title : '设备列表';

    return (
      <DocumentTitle title={pageTitle}>
        <Fragment>
          <NavBar
            style={{
              width: '100%', position: 'fixed', top: 0, zIndex: 3,
            }}
            mode="dark"
            onLeftClick={this.navBack}
            icon={<FontAwesomeIcon icon={faArrowCircleLeft} fixedWidth />}
            rightContent={[
              <RefreshIcon key="refresh" loading={syncing} onClick={this.refreshList} />,
            ]}
          >
            { pageTitle }
          </NavBar>

          <FixedContent>
            <SearchBar
              placeholder="开始编号 结束编号"
              maxLength={10}
              value={keyword}
              onChange={this.handleSearchChange}
              onSubmit={this.handleSearch}
              onCancel={this.handleSearchCancel}
            />

            <InfiniteScroll
              loadMore={this.loadMore}
              hasMore={hasMore}
              loader={<Loader key="loader" />}
              threshold={50}
            >
              {
                devices.map(item => (
                  <Fragment key={item.id}>
                    <WhiteSpace size="sm" />
                    <Card
                      full
                      onClick={() => { this.handleClickItem(item); }}
                    >
                      <Card.Header
                        title={item.name}
                        extra={item.category}
                        thumb={<FontAwesomeIcon style={{ paddingRight: '1em' }} icon={item.status === 1 ? faEye : faEyeSlash} color="skyblue" size="lg" />}
                      />
                      <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                        <Flex style={{ width: '100%' }}>
                          {
                            item.attributes.map(attr => (
                              <Flex.Item key={attr.name}>
                                {attr.title}
                                ：
                                {attr.value}
                              </Flex.Item>
                            ))
                          }
                        </Flex>
                      </Card.Body>
                    </Card>
                  </Fragment>
                ))
              }
            </InfiniteScroll>
          </FixedContent>

          <WhiteSpace size="sm" />
          <NoMoreData hide={hasMore} />
        </Fragment>
      </DocumentTitle>
    );
  }
}

Devices.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      user: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    state: PropTypes.shape({
      title: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default withRouter(Devices);
